import MicroModal from 'micromodal';
import $ from 'cash-dom';
import LocalStorage from './core/local-storage';
import * as form from './core/form';
import {
    formAutoFill,
    checkErrorFactory,
    setUserInfoFactory,
    getUserInfoFactory
} from './core/helper';
import {
    getParam,
    getShareLink,
    copyToClipboard
} from './core/utils';
import Html from './core/html';
import EventBus from "./core/event";
import Api from './core/api';
import Http from './core/http';
import Mission from './core/mission';
import {
    createSound
} from './core/sound';
import {
    checkAuthParam,
    loginFB,
    loginZalo,
    loginGoogle,
    verifyPlayCode,
    verifyNoAuth,
    verifyManyChat,
    checkLoginWithManychat,
    showUserInfoFormFactory,
    loginHandlerFactory,
    handleLoginButtons,
    saveRefFactory,
    saveFormInfoFactory,
    isUserEnoughData,
    loginBeforeInfoForm
} from './core/auth';
import {
    format
} from 'date-fns';
import LuckyWheel from './game/canvas';
import initPopup from './popup';
import {
    validateForm
} from './core/form';
import Reward from './core/reward';
import Cookie from './core/cookie';

function Woay(selector, Options, soundObj) {
    const {
        Wheel,
        SETTINGS
    } = Options;
    const api = new Api(Wheel);
    const mission = new Mission(api);
    var http = new Http();
    var eventBus = new EventBus();
    const html = new Html(eventBus);
    const local = new LocalStorage(Wheel);
    const cookie = new Cookie(Wheel);
    const theWheel = LuckyWheel(selector, Options, eventBus);
    let _userInfo = {};
    let hasShowInfo = false;
    const sound = createSound(Options, soundObj);
    const checkError = checkErrorFactory(html, local, SETTINGS);
    const getUserInfo = getUserInfoFactory(_userInfo);
    const setUserInfo = setUserInfoFactory(_userInfo, local);
    const saveRef = saveRefFactory(local);
    const saveFormInfo = saveFormInfoFactory(Wheel, html, api, local, _userInfo, checkError, verifyLoginDone, () => {
        hasShowInfo = true;
    });
    const loginHandler = loginHandlerFactory(Wheel, _userInfo, saveFormInfo, formAutoFill);
    const showUserInfoForm = showUserInfoFormFactory(Wheel, _userInfo, saveFormInfo, formAutoFill);
    const reward = new Reward(Options, api, checkError, eventBus, _userInfo, saveFormInfo, sound);
    html.add3rdPartyLib();
    html.injectHtml(Options);

    checkLoginWithManychat(html, api, checkError, verifyLoginDone);

    async function verifyLoginDone(data) {
        if (!data.jwt) {
            throw 'Dữ liệu đăng nhập không hợp lệ';
        }
        api.http.setToken(data.jwt);
        saveFormInfo(data);
        console.log('hasLogin', reward.hasLogin);
        if (reward.hasLogin) return;
        reward.hasLogin = true;
        await Promise.all([reward.fetchRewards(), reward.updateTurn()]);
        reward.updateTurnCount();
        if (!reward.isOutOfTurn()) {
            await reward.claimReward();
        }
        $('.btn-check-reward').css('display', 'block');
        eventBus.emit('login-done');
    }

    function checkSpinning() {
        if (theWheel.isSpinning()) {
            vanillaToast.warning('Vòng quay đang quay, vui lòng đợi trong giây lát', {
                duration: 1000,
                fadeDuration: 200
            })
            return true;
        }
    }

    async function start() {
        // Kiểm tra login
        if (!reward.hasLogin) {
            return loginHandler();
        }

        if (!isUserEnoughData(Wheel, _userInfo)) {
            const filled = showUserInfoForm();
            if (!filled) return;
        }

        if (checkSpinning()) return;

        if (!reward.isAwading()) {
            startErrorHandler();
        }

        if (reward.isOutOfTurn() && !Options.Wheel.is_test_mode) {
            html.getModalOutOfTurn(Options, SETTINGS);
            eventBus.emit('outOfTurn');
            return;
        }

        let turn = reward.getRemainTurnCount();
        //claim nếu còn lượt chơi
        if (turn) {
            ('con luot');
            await reward.claimReward();
            reward.updateTurnCount();
        }

        sound.playEffect("rolling_audio");
        return reward.award(theReward => {
            theWheel.rollToSku(theReward.sku);
        });
    }

    function startErrorHandler() {
        if (reward.error = 'IS_AWARDING') {
            vanillaToast.warning('Vui lòng đợi api awarding', {
                duration: 2000,
                fadeDuration: 200
            })
        }
    }

    // MAIN LOGIC
    $('.btn-woay, .bigButton, .btn-play').on('click', start);
    checkAuthParam(Options, function (data, method) {
        console.trace('checkAuthParam');
        verifyLoginDone(data);
    });
    $(document).on('click', '.btn-check-reward', function () {
        if (checkSpinning()) return;
        html.closeAllModal('main.js:114');
        reward.checkRewardList();
    });

    // Handle login buttons
    handleLoginButtons(Options, html, api, checkError, verifyLoginDone, saveFormInfo);

    eventBus.on("wheel-stop", async function () {
        var r = reward.currentReward;
        if (r.code || r.sku == "BADLUCK") {
            reward.updateTurnCount();
            sound.stopEffect("rolling_audio");
            return reward.congratulate(r.sku !== "BADLUCK", Options.is_popup);
        }
    });

    return {
        eventBus,
        start,
        login: {
            playCode: verifyPlayCode,
            noAuth: verifyNoAuth,
            manyChat: verifyManyChat,
            loginHandler,
            verifyLoginDone,
        },
        user: {
            showUserInfoForm,
            get: getUserInfo,
            set: setUserInfo,
        },
        formData: {
            saveFormInfo,
        },
        mission: mission,
        api: api,
        http: http,
        html: html,
        form: form,
        local: local,
        cookie: cookie,
        $,
        getParam,
        loginFB,
        loginZalo,
        loginGoogle,
        validateForm,
        reward,
        congratulate: reward.congratulate,
        rollToSku: theWheel.rollToSku,
        copyToClipboard,
        saveRefToCookie: saveRef,
        saveRef,
        getShareLink: () => getShareLink(_userInfo),
        checkSpinning,
        start,
        format
    }
}
Woay.$ = $;
Woay.initPopup = initPopup;
Woay.EventBus = EventBus;
Woay.local = LocalStorage;
Woay.misc = {
    getQueryParam: getParam
}
window.Woay = Woay;
window.MicroModal = MicroModal;